import { useCallback, useContext } from "react";

import { Box } from "@mui/material";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { Permission } from "@/components/UserManagement/types";
import { userPermissionChecks } from "@/components/UserManagement/utils";
import { AuthStateContext } from "@/contexts/AuthContext";

import MessageHistoryPanel from "./AllHistoryComponents/MessageHistoryPanel";
import MessagingUsersList from "./AllHistoryComponents/MessagingUsersList";

const AllHistoryView = () => {
  const { orgId, rubiUserId } = useParams<{
    orgId: string;
    rubiUserId?: string;
  }>();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthStateContext);

  const { canViewMessageAllHistory } = userPermissionChecks(
    currentUser?.permissions?.map((p) => p.title as Permission) ?? [],
  );

  const handleSelectUser = useCallback(
    (userId: string) => {
      navigate(`/rubimessage/${orgId}/history/${userId}`);
    },
    [orgId, navigate],
  );

  if (!canViewMessageAllHistory) {
    return <Navigate to={`/rubimessage/${orgId}`} replace />;
  }

  if (!orgId) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", height: "calc(100vh - 64px)" }}>
      <Box
        sx={{
          width: 360,
          minWidth: 280,
          borderRight: "1px solid",
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MessagingUsersList
          orgId={orgId}
          selectedUserId={rubiUserId}
          onSelectUser={handleSelectUser}
        />
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", p: 3 }}>
        <MessageHistoryPanel orgId={orgId} rubiUserId={rubiUserId} />
      </Box>
    </Box>
  );
};

export default AllHistoryView;
